<template>
	<div class="m-search flex" :class="{'z-fold': foldState}" :column="column">
		<div class="flex-grow">
			<c-form ref="form" style="padding: 0" @enter="search()">
				<slot></slot>
				<m-search-item v-for="(item, i) in filterList" :key="i" :label="item.label" :colspan="item.type == 'time' ? 2 : 1">
					<template v-if="item.type == 'number'">
						<div class="flex-center">
							<c-input
								v-model="item.value[0]"
								class="flex-grow"
								type="number"
								:decimal="item.config.attr.includes('decimal') ? item.config.decimal : 0"
								:range="[-Infinity, item.value[1]]"
								placeholder="最小值"
							></c-input>
							<span style="min-width: 30px; text-align: center;">-</span>
							<c-input
								v-model="item.value[1]"
								class="flex-grow"
								type="number"
								:decimal="item.config.attr.includes('decimal') ? item.config.decimal : 0"
								:range="[item.value[0], Infinity]"
								placeholder="最大值"
							></c-input>
						</div>
					</template>
					<template v-else-if="item.type == 'time'">
						<c-datetime
							v-model="item.value"
							range
							:type="item.config.format.split('|')[1]"
							:format="item.config.format.split('|')[0]"
							:time-accuracy="item.config.format.split('|')[2]"
						></c-datetime>
					</template>
					<template v-else-if="item.type == 'option'">
						<c-select v-if="item.custom" v-model="item.value" :options="item.config.options" multiple search></c-select>
						<c-select v-else-if="item.config.dict_config.dictType == 'DBDIC'" v-model="item.value" async multiple @search="getOptions(item.config.dict_config.dictName, arguments[0], arguments[1])"></c-select>
						<c-select v-else v-model="item.value" :options="$store.state[item.config.dict_config.dictName]" multiple search></c-select>
					</template>
					<template v-else-if="item.type == 'rel_object'">
						<c-select v-model="item.value" async multiple @search="getObjectOptions(item, arguments[0], arguments[1])"></c-select>
					</template>
					<template v-else>
						<c-input v-model="item.value"></c-input>
					</template>
				</m-search-item>
			</c-form>
		</div>
		<div v-if="button" class="m-search-handle flex-center-cross">
			<slot v-if="$slots.button" name="button"></slot>
			<template v-else>
				<c-button color="main" size="search" @click="search">查询</c-button>
				<c-button v-if="reset" size="search" @click="clear">重置条件</c-button>
			</template>
		</div>
		<div v-if="lines > 2" class="m-search-fold flex-center" @click="foldState = foldState ? 0 : 1"><i class="tf">&#xe6fc;</i></div>
	</div>
</template>

<script>
	export default {
		name: 'mSearch',

		props: {
			column: [String, Number],
			defaultData: Object,
			initData: Object,
			extendData: Object,
			fold: Boolean,
			button: {
				type: Boolean,
				default: true
			},
			reset: {
				type: Boolean,
				default: true
			},
			extendField: {
				type: Array,
				default() {
					return [];
				}
			}
		},

		data() {
			return {
				viewListHandle: false,
				viewFilter: [],
				lines: 1,
				foldState: false
			}
		},

		computed: {
			filterList() {
				return this.viewFilter.concat(this.extendField).map(item => {
					let type = item.is_custom == 1 ? item.config_json.type : {
						1: 'text',
						2: 'number',
						3: 'time',
						4: 'option'
					}[item.field_type];

					return {
						custom: item.is_custom == 1,
						id: item.id || item.field_id,
						code: item.field_code,
						label: item.field_title,
						type: type,
						value: ['number', 'time'].includes(type) ? ['', ''] : type == 'option' ? [] : '',
						config: item.config_json
					}
				});
			}
		},

		watch: {
			foldState(val) {
				if (val !== false) {
					localStorage.setItem('searchFoldState', val);
				}
			},

			filterList() {
				this.foldState !== false && this.updateFoldState();
			}
		},

		mounted() {
			if (this.defaultData || this.initData) {
				this.set(Object.assign({}, this.defaultData, this.initData));
			}

			if (this.$parent.$options.name == 'viewList' && this.$parent.workType) {
				this.request({
					url: '/sys_user_view/filter_field_list',
					data: {
						work_type_id: this.$parent.workType,
						is_custom: 1
					},
					success: data => {
						data.forEach(item => item.is_custom = 1);
						this.viewFilter = data;
					}
				});
			}

			if (this.fold) {
				this.initFold();
			}
		},
		
		beforeDestroy() {
			this.foldState !== false && window.removeEventListener('resize', this.updateFoldState);
		},
		
		methods: {
			initFold() {
				this.foldState = parseInt(localStorage.getItem('searchFoldState')) || 1;
				this.updateFoldState();
				window.addEventListener('resize', this.updateFoldState);
			},

			updateFoldState() {
				this.$nextTick(() => {
					let list = [], $items = this.$el.querySelectorAll('.m-search-item');
					$items.forEach($item => {
						$item.setAttribute('update', true);
					});
					$items.forEach($item => {
						if (!list.includes($item.offsetTop)) {
							list.push($item.offsetTop);
						}
						$item.setAttribute('more', list.length > 2);
					});
					$items.forEach($item => {
						$item.setAttribute('update', false);
					});
					this.lines = list.length;
				});
			},
			
			search(data, callback) {
				if (data) {
					this.viewListHandle(data, callback);
					return;
				}
				this._lastSearch = Object.assign(this.$refs.form.get(), {
					user_filter_condition: this.filterList.map(item => {
						return {
							field_id: item.id,
							field_code: item.code,
							field_type: item.type,
							query_operator: item.type == 'text' ? 'like' : ['option', 'rel_object'].includes(item.type) ? 'in' : 'range',
							field_value: item.type == 'text'
								? item.value.trim()
								: ['option', 'rel_object'].includes(item.type)
									? item.value
									: item.value.map(item => item || null)
						}
					}).filter(item => Array.isArray(item.field_value) ? item.field_value.filter(item => item).length : item.field_value)
				});
				if (this.viewListHandle) {
					this.viewListHandle(this.get());
				} else {
					this.$emit('search', this.get());
				}
			},
			
			set(data) {
				this.$refs.form.set(data);
			},
			
			get() {
				return Object.assign({}, this._lastSearch, this.extendData);
			},
			
			clear() {
				this.$refs.form.clear();
				if (this.defaultData) {
					this.set(this.defaultData);
				}
				this._lastSearch = this.$refs.form.get();
				this.$emit('clear');
			},

			getOptions(code, keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: code,
						keyword
					},
					success: data => {
						resolve(data);
					}
				});
			},

			getObjectOptions(field, keyword, resolve) {
				this.request({
					url: '/sys_field/relation/data_list',
					data: {
						query_type: 0,
						relation_field_id: field.id,
						keyword
					},
					success: data => {
						resolve(data.map(item => {
							return {
								name: item.display_value,
								value: item.id
							}
						}))
					}
				})
			}
		}
	}
</script>

<style lang="stylus">
	.m-search {
		position: relative;
		padding: 10px 7px 10px 12px;

		.c-form {
			gap: 5px;
		}
	
		&-fold {
			position: absolute;
			left: 50%;
			bottom: 0;
			box-sizing: border-box;
			width: 36px;
			height: 14px;
			border: 1px solid var(--table-border);
			border-radius: 7px;
			font-size: 10px;
			color: #666;
			background: #fff;
			cursor: pointer;
			transform: translate(-50%,50%);
			
			&:hover {
				color: var(--color-main);
			}
			
			^[-1].z-fold ^[-2..-1] .tf {
				transform: rotate(180deg);
			}
		}
		
		&-item {
			width: calc(20% - 5px);
			height: 32px;
			border-radius: 2px;
			background: #F9F9F9;
	
			^[-1].z-fold ^[-2..-1] {
				&[more="true"][update="false"] {
					display: none;
				}
			}

			^[-1][column='1'] & {
				width: calc(100% - 5px);
			}

			^[-1][column='2'] & {
				width: calc(50% - 5px);

				&[colspan="2"] {
					width: calc(100% - 5px);
				}
			}

			^[-1][column='3'] & {
				width: calc(33.3333% - 5px);

				&[colspan="2"] {
					width: calc(66.6666% - 5px);
				}
			}

			^[-1][column='4'] & {
				width: calc(25% - 5px);

				&[colspan="2"] {
					width: calc(50% - 5px);
				}
			}

			^[-1]:not([column]) & {
				@media screen and (max-width: 1699px) {
					width: calc(25% - 5px);
				}

				@media screen and (max-width: 1399px) {
					width: calc(33.3333% - 5px);
				}

				@media screen and (max-width: 1099px) {
					width: calc(50% - 5px);
				}

				&[colspan="2"] {
					width: calc(40% - 5px);

					@media screen and (max-width: 1699px) {
						width: calc(50% - 5px);
					}

					@media screen and (max-width: 1399px) {
						width: calc(66.6666% - 5px);
					}

					@media screen and (max-width: 1099px) {
						width: calc(100% - 5px);
					}
				}
			}
			
			&:focus-within {
				background: #fff;
				outline: 1px solid #999;
			}
			
			label {
				margin: 0 12px;
				font-size: 12px;
				color: #666;
			}
			
			.c-input,
			.c-select,
			.c-datetime {
				height: 32px;
				border: none;
				background: none;

				input {
					font-size: 12px;
				}
			}
			.c-select-current {
				font-size: 12px;
			}
			.c-select-tag-item {
				background: #fff;
			}
			
			.c-checkbox-group {
				margin-top: 2px;
			}
			.c-checkbox span {
				font-size: 12px;
			}
		}
		
		&-handle {
			align-items: flex-start;
			margin-left: 10px;
			
			.c-button {
				margin-right: 9px;
			}
		}
	}
</style>
